<template>
  <gj-modal
      size="full-screen"
      :visible.sync="modalVisible"
      :footer="false">
    <template #header>
      关联ASIN<span class="modal-secondary-title">(搜索词：{{item.query | defaultShow}})</span>
    </template>
    <template #content>
      <app-base-main
          no-padding
          :table-shadow="false"
          >
        <template #filter-group>
          <app-filter-group
              :reset="false"
              @query="$gjNoticeQuery">
            <gj-select-input
                v-model="keyword"
                :options="[
                  {id: 'asin', text: 'ASIN'},
                  {id: 'msku', text: 'MSKU'},
                  {id: 'title', text: '商品标题'},
                ]"
            ></gj-select-input>
            <gj-date-picker
                v-model="date"
                type="daterange"
                tooltip="数据时间"
                :max-day-length="180"
                :clearable="false"
            ></gj-date-picker>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              :index="false"
              name="relateAsinAnalysis"
              :loading="loading"
              size="has-picture"
              :offset-height="22"
              :data="tableData"
              :columns="columns"
              :pagination="pagination"
              :default-sort="defaultSort"
              @sort-change="$gjSortChange"
              :show-overflow="false">
            <template v-slot:listingInfo="{row}">
              <el-row
                  type="flex"
                  align="middle">
                <div>
                  <div>
                    <gj-tooltip
                        :text-line="1"
                        :content="row.title"
                        class="listing-title">
                      {{row.title | defaultShow}}
                    </gj-tooltip>
                  </div>
                  <el-row style="margin: 2px 0;">
                    <el-col :span="12">
                      <span class="asin-label">ASIN：</span>
                      <span class="asin-value">
                        <gj-link :href="row.asinAmazonUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
                      </span>
                    </el-col>
                    <el-col :span="12">
                      <span class="variationAsin-label">父ASIN：</span>
                      <span class="variationAsin-value">
                        {{row.variationAsin | defaultShow}}
                      </span>
                    </el-col>
                  </el-row>
                  <div>
                    <span class="msku-label">MSKU：</span>
                    <span class="msku-value">
                      {{ row.msku | defaultShow }}
                    </span>
                  </div>
                </div>
              </el-row>
            </template>
            <template v-slot:campaignName="{row}">
              <app-ad-route-link
                  :market-id="marketId"
                  :type="AdTypeEnum.SP"
                  :campaign="row">
                {{row.campaignName}}
              </app-ad-route-link>
            </template>
            <template v-slot:groupName="{row}">
              <app-ad-route-link
                  :market-id="marketId"
                  :type="AdTypeEnum.SP"
                  :campaign="row"
                  :group="row"
                  :group-targeting-type="AdGroupEnum.SP.targetingType.KEYWORD">
                {{row.groupName}}
              </app-ad-route-link>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin} from "../../../../../../minxins";
  import {adFields} from "../../../common/fields";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {subDays} from 'date-fns';
  import {getAdsSearchKeywordPerformanceAsin} from "../../../../../../api/ad";
  import {isMeaningful} from "../../../../../../utils/common";
  import {adDefaultSortMixin, currencySymbolMixin} from "../../../common/mixin";
  import {AdCampaignEnum, AdGroupEnum, AdTypeEnum} from "../../../common/enum";
  import AppAdRouteLink from "../../../common/components/app-ad-route-link";

  export default {
    name: "app-ad-keyword-relate-asin-modal",
    components: {AppAdRouteLink},
    mixins: [modalMixIn, queryMixin, currencySymbolMixin, adDefaultSortMixin],
    props: {
      marketId: {
        required: true,
      },
      currencySymbol: {
        required: true,
      },
      item: {
        required: true
      },
      queryDate: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          adFields.picture,
          {id: 'listingInfo', header: '商品信息', field: 'slot:listingInfo', minWidth: '300px', fixed: 'left'},
          {...adFields.campaignName, help: null, fixed: null, copyable: true},
          {...adFields.groupName, help: null, fixed: null, copyable: true},
          {...adFields.servingStatus, options: AdCampaignEnum.SP.servingStatusOption, defaultShow: '广告活动已暂停'},
          // adFields.creationDate,
          adFields.impressions,
          adFields.clicks,
          adFields.ctr,
          adFields.cost,
          adFields.cpc,
          adFields.orders,
          adFields.cvr,
          adFields.cpa,
          adFields.sales,
          adFields.acos,
          // adFields.acoas,
          // adFields.asoas,
          adFields.roas
        ],
        AdTypeEnum: AdTypeEnum,
        AdGroupEnum: AdGroupEnum,
        keyword: {
          key: 'asin',
          value: null,
        },
        date: [subDays(new Date(), 6), new Date()],
      }
    },
    created() {
      /*this.sort.prop = 'impressions';*/
      this.date = this.queryDate;
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            marketId: this.marketId,
            query: this.item.query,
            startDate: convertToDate(this.date[0]),
            endDate: convertToDate(this.date[1]),
          },
          ...this.queryPagination,
          ...this.querySort
        };
        params.model[this.keyword.key] = this.keyword.value;
        // 查询
        this.loading = true;
        getAdsSearchKeywordPerformanceAsin(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = this.currencySymbolMixin(data.records || [], this.currencySymbol);
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          })
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    padding-top: 12px;
  }
  /deep/ .gj-table .gj-help--icon .gj-icon{
    color: #999;
  }
</style>
